import { View, StyleSheet } from 'react-native';
import { FC, ReactNode } from 'react';

const ChatWidget: FC<{ header?: ReactNode; children?: ReactNode }> = ({
  header,
  children,
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.widget}>
        {header}
        <View style={styles.body}>{children}</View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 10,
  },
  widget: {
    padding: 10,
    backgroundColor: 'rgba(5, 22, 51, 0.5)',
    borderRadius: 20,
    // paddingBottom: 34,
    maxWidth: 500,
    maxHeight: '100%',
  },
  body: {
    flexShrink: 1,
  },
});

export default ChatWidget;
